import { TextField } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import InfoIcon from "@mui/icons-material/Info";
import formatDateAndTime from "../../common/formatDateAndTime";
import moment from "moment";

const Updatedetails = ({
  summaryDetails,
  getBookingDetail,
  getAllBookings,
  setOpenTab
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.fleetBookingStatus;
  let token = localStorage.getItem("token");
  const [pickupType, setPickupType] = useState("hubDelivery");
  const [dropType, setDropType] = useState("hubPickup");
  const [inputValues, setInputValues] = useState({});
  const [errors, setErrors] = useState({});
  const [discountSelection, setDiscountSelection] = useState(false);
  const [discountMode, setDiscountMode] = useState(null);
  const [hubs, setHubs] = useState(null);
  const [vehicleDetailsData, setVehicleDetailsData] = useState({
    id: "",
    name: "",
    vehicleNo: "",
    comment: "",
  });

  const validateField = (key, value) => {
    let error = "";

    if (!value || value.toString().trim() === "") {
      error = `${key} is required`;
    } else {
      switch (key) {
        case "destination":
          if (value.length < 3) error = "Enter destination";
          break;

        // case "discount":
        //   if (!/^[0-9]+$/.test(value))
        //     error = "Only numbers allowed, no alphabets/special chars";
        //   break;

        case "pickupcharges":
        case "deliverycharges":
          if (!/^[0-9]+$/.test(value)) error = "Charges must be numeric only";
          break;

        case "deliveryaddress":
          if (value.trim().length < 5) error = "Delivery address required";
          break;

        case "pickupaddress":
          if (value.trim().length < 5) error = "Pickup address required";
          break;

        default:
          break;
      }
    }

    setErrors((prev) => ({ ...prev, [key]: error }));

    // // 🔔 Fire toast if error exists
    // if (error) {
    //   toast.error(error);
    // }

    return error === "";
  };

  const handleInputChange = (event, inputKey) => {
    const value =
      event?.target?.value !== undefined ? event.target.value : event;

    if (inputKey === "discount" && discountMode === null) {
      setDiscountSelection(true);
      return;
    }

    setInputValues((prev) => ({
      ...prev,
      [inputKey]: value,
    }));

    validateField(inputKey, value);
  };

  const getHubNames = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/hubs?limit=100&cityId=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setHubs(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (summaryDetails?.cityId) {
      getHubNames(summaryDetails?.cityId);
    }
  }, [summaryDetails]);

  const tripdetailsInput = [
    {
      label: "Pickup Type",
      type: "tab",
      value: "pickuptype",
      subCategory: ["Self Pickup", "Delivery to Customer"],
      defailtvalues: ["hubDelivery", "homeDelivery"],
    },
    {
      label: "Drop Type",
      type: "tab",
      value: "droptype",
      subCategory: ["Self Drop", "Pickup from Customer"],
      defailtvalues: ["hubPickup", "homePickup"],
    },
  ];

  const deliveryInputs = {
    pickuptype: [
      {
        label: "Delivery Address",
        type: "text",
        value: "deliveryaddress",
        allowOnlyNumbers: false,
      },
      {
        label: "Delivery Charges",
        type: "text",
        value: "deliverycharges",
        allowOnlyNumbers: true,
      },
    ],
    droptype: [
      {
        label: "Pickup Address",
        type: "text",
        value: "pickupaddress",
        allowOnlyNumbers: false,
      },
      {
        label: "Pickup Charges",
        type: "text",
        value: "pickupcharges",
        allowOnlyNumbers: true,
      },
    ],
  };

  const getUniqueInputs = (inputs) => {
    const seen = new Set();
    return inputs.filter((input) => {
      if (seen.has(input.value)) return false;
      seen.add(input.value);
      return true;
    });
  };

  const calculateFinalPrice = () => {
    // if (!selectedVehicle) return 0;

    const baseFare =
      Number(summaryDetails?.weekdayRent || 0) +
      Number(summaryDetails?.weekendRent || 0);

    const pickupCharge = Number(inputValues?.pickupcharges || 0);
    const deliveryCharge = Number(inputValues?.deliverycharges || 0);
    const securityDeposit = Number(summaryDetails?.securityDeposit || 0);

    if (discountMode === false) {
      // percentage discount
      const discount = Number(inputValues?.discount || 0);
      const discountedBase = Number(
        (baseFare - baseFare * (discount / 100)).toFixed(2)
      );
      const taxAmount = Number((discountedBase * 0.18).toFixed(2));

      const finalPrice = Number(
        (
          discountedBase +
          taxAmount +
          pickupCharge +
          deliveryCharge +
          securityDeposit
        ).toFixed(2)
      );

      return { finalPrice, taxAmount, discountedBase };
    } else if (discountMode === true) {
      // fixed amount discount
      const discount = Number(inputValues?.discount || 0);
      if (discount > baseFare) {
        toast.error("Discount cannot be greater than base fare");
        return 0;
      }

      const discountedBase = Number((baseFare - discount).toFixed(2));
      const taxAmount = Number((discountedBase * 0.18).toFixed(2));

      const finalPrice = Number(
        (
          discountedBase +
          taxAmount +
          pickupCharge +
          deliveryCharge +
          securityDeposit
        ).toFixed(2)
      );

      return { finalPrice, taxAmount, discountedBase };
    } else {
      // no discount
      const taxAmount = Number((baseFare * 0.18).toFixed(2));

      const finalPrice = Number(
        (
          baseFare +
          taxAmount +
          pickupCharge +
          deliveryCharge +
          securityDeposit
        ).toFixed(2)
      );
      return { finalPrice, taxAmount, discountedBase: baseFare };
    }
  };

  const getDiscountDetails = () => {
    // if (!selectedVehicle) return { discountAmount: 0, discountPercentage: 0 };

    const baseFare =
      Number(summaryDetails?.weekdayRent || 0) +
      Number(summaryDetails?.weekendRent || 0);

    const discountValue = Number(inputValues?.discount || 0);

    if (!discountMode) {
      // % mode → user enters percentage
      const discountAmount = Math.round((baseFare * discountValue) / 100);
      return {
        discountAmount,
        discountPercentage: discountValue,
      };
    } else {
      // ₹ mode → user enters amount
      const discountAmount = discountValue;
      const discountPercentage = baseFare
        ? ((discountAmount / baseFare) * 100).toFixed(2)
        : 0;
      return {
        discountAmount,
        discountPercentage,
      };
    }
  };

  const taxAmount = useMemo(() => {
    const baseFare =
      Number(summaryDetails?.weekdayRent || 0) +
      Number(summaryDetails?.weekendRent || 0);

    const discountValue = Number(inputValues?.discount || 0);

    let discount = 0;

    if (!discountMode) {
      discount = (baseFare * discountValue) / 100;
    } else {
      discount = discountValue;
    }

    const discountedBase = baseFare - discount;

    return Number((discountedBase * 0.18).toFixed(2));
  }, [summaryDetails, inputValues?.discount, inputValues?.discountType]);

  const postVehicleBooking = async () => {
    toast.loading("Processing... Please wait", {
      id: "postbooking",
      position: "bottom-center",
    });

    const start = moment(
      `${inputValues?.startdate} ${inputValues?.starttime}`,
      "YYYY-MM-DD HH:mm"
    );

    const end = moment(
      `${inputValues?.enddate} ${inputValues?.endtime}`,
      "YYYY-MM-DD HH:mm"
    );

    if (!inputValues?.destination) {
      toast.dismiss("postbooking");
      return setErrors((prev) => ({
        ...prev,
        destination: "Enter destination to generate the inquiry",
      }));
    }

    const pickupTypeAddress = hubs?.find(
      (item) => summaryDetails?.hubId === item?.id
    )?.hubAddress;

    const deliveryTypeAddress = hubs?.find(
      (item) => summaryDetails?.hubId === item?.id
    )?.hubAddress;

    if (Object.keys(inputValues).length >= 1) {
      try {
        const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            id: summaryDetails?.id,
            destination: inputValues?.destination,
            discountPercentage: Number(
              getDiscountDetails()?.discountPercentage
            ),
            discountAmount: getDiscountDetails()?.discountAmount,
            taxAmount: taxAmount,
            pickupAddress: inputValues?.pickupaddress
              ? inputValues?.pickupaddress
              : deliveryTypeAddress,
            deliveryAddress: inputValues?.deliveryaddress
              ? inputValues?.deliveryaddress
              : pickupTypeAddress,
            pickupCharges: Number(inputValues?.pickupcharges) || 0,
            deliveryCharges: Number(inputValues?.deliverycharges) || 0,
            deliveryType: pickupType,
            deliveryTypeInt: pickupType === "homeDelivery" ? 1 : 0,
            pickupTypeInt: dropType === "homePickup" ? 1 : 0,
            pickupType: dropType,
            costToCustomer: calculateFinalPrice()?.finalPrice,
            source: "admin",
          }),
        });

        const data = await response.json();

        toast.dismiss("postbooking");

        if (data?.statusCode === "0100") {
          toast.success("Details Updated successfully!", {
            position: "bottom-center",
          });
          getBookingDetail(summaryDetails?.inquiryCode, "inquiry");
        } else {
          toast.error(data?.message || "Something went wrong!", {
            position: "bottom-center",
          });
        }

        return data;
      } catch (error) {
        toast.dismiss("postbooking");

        toast.error("API failed, please try again!", {
          position: "bottom-center",
        });

        return console.error("Error fetching Hub Names:", error);
      }
    } else {
      toast.dismiss("postbooking");
      toast.error("Fill the Basic customer and trip details");
    }
  };

  const initiateBookingAPI = async (type) => {
    if (!vehicleDetailsData?.comment) {
      toast.dismiss("initiate");
      return toast.error("Enter comment to close or initate booking", {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      });
    }

    let payload;

    if (type === "Close") {
      payload = {
        id: summaryDetails?.id,
        comment: vehicleDetailsData?.comment,
        bookingStatus: fleetBookingStatus?.inverted?.inquiryClosed,
        isInquiryClosed: true,
      };
    }

    toast.loading("Processing... Please wait", {
      id: "initiate", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      

      toast.dismiss("initiate");

      if (data?.statusCode === "0100") {
        toast.success("Booking updated successfully!", {
          position: "bottom-center",
        });
        setOpenTab(false)
        getAllBookings();
      } else {
        toast.error(data?.message || "Something went wrong!", {
          position: "bottom-center",
        });
      }

      return data;
    } catch (error) {
      toast.dismiss("initiate");

      toast.error("API failed, please try again!", {
        position: "bottom-center",
      });

      return console.error("Error fetching initiate booking:", error);
    }
  };

  return (
    <div className="mt-4">
      <div className="grid grid-cols-3 p-6">
        {" "}
        {tripdetailsInput.map((input, index) => (
          <div key={index}>
            <h1 className="font-medium text-md mb-4">{input.label}</h1>
            <div className="flex gap-4">
              {input.subCategory.map((option, i) => (
                <button
                  key={i}
                  onClick={() => {
                    if (input.value === "pickuptype") {
                      setPickupType(input.defailtvalues[i]);
                      setDiscountMode(null);

                      setInputValues((prev) => ({
                        ...prev,
                        deliveryaddress: null || "",
                        deliverycharges: 0,
                        discount: 0,
                        destination: null,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        deliveryaddress: "",
                        deliverycharges: "",
                        pickupaddress: "",
                        pickupcharges: "",
                      }));
                    } else {
                      setDropType(input.defailtvalues[i]);
                      setDiscountMode(null);

                      setInputValues((prev) => ({
                        ...prev,
                        pickupaddress: null || "",
                        pickupcharges: 0,
                        discount: 0,
                        destination: null,
                      }));
                      setErrors((prev) => ({
                        ...prev,
                        deliveryaddress: "",
                        deliverycharges: "",
                        pickupaddress: "",
                        pickupcharges: "",
                      }));
                    }
                  }}
                  className={`px-4 py-2 text-xs rounded-md ${
                    (input.value === "pickuptype" &&
                      pickupType === input.defailtvalues[i]) ||
                    (input.value === "droptype" &&
                      dropType === input.defailtvalues[i])
                      ? "bg-blue-100 border border-blue-500 shadow-md text-black"
                      : "bg-white text-black border-2"
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
        ))}
        <label className="block">
          <span className="block text-lg font-medium text-gray-700 mb-1">
            Discount Type
          </span>
          <select
            value={discountMode === null ? "" : discountMode.toString()}
            onChange={(e) => {
              if (e.target.value === "") {
                setDiscountMode(null);
              } else {
                setDiscountSelection(false);
                setDiscountMode(e.target.value === "true"); // ✅ ensures boolean
              }
            }}
            className="w-40 rounded-md border border-gray-300 bg-white py-2 px-3 text-sm shadow-sm"
          >
            <option value="">Select</option>
            <option value="false">By Percentage</option>
            <option value="true">By Amount</option>
          </select>
        </label>
      </div>

      {(() => {
        let inputs = [];
        if (pickupType === "homeDelivery") {
          inputs = inputs.concat(deliveryInputs.pickuptype);
        }
        if (dropType === "homePickup") {
          inputs = inputs.concat(deliveryInputs.droptype);
        }

        const uniqueInputs = getUniqueInputs(inputs);

        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 p-6">
            {uniqueInputs.map((input, index) => (
              <TextField
                key={index}
                fullWidth
                label={input.label}
                type={input.type}
                InputLabelProps={{ shrink: true }}
                value={inputValues[input.value] || ""}
                onChange={(event) => handleInputChange(event, input.value)}
                onKeyDown={(e) => {
                  if (input.allowOnlyNumbers) {
                    const allowed = [
                      "Backspace",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                      ".",
                    ];
                    if (!/^[0-9]$/.test(e.key) && !allowed.includes(e.key)) {
                      e.preventDefault();
                    }
                  }
                }}
                error={Boolean(errors[input.value])}
                helperText={errors[input.value] || ""}
              />
            ))}

            {(pickupType || dropType) && (
              <>
                <TextField
                  fullWidth
                  label="Destination"
                  InputLabelProps={{ shrink: true }}
                  value={inputValues.destination || ""}
                  onChange={(e) => handleInputChange(e, "destination")}
                  error={Boolean(errors.destination)}
                  helperText={errors.destination || ""}
                />

                <TextField
                  fullWidth
                  label="Discount"
                  InputLabelProps={{ shrink: true }}
                  value={inputValues.discount || ""}
                  onChange={(e) =>
                    /^\d*$/.test(e.target.value) &&
                    handleInputChange(e, "discount")
                  }
                />
              </>
            )}
          </div>
        );
      })()}
      {discountSelection && (
        <p className="text-end text-red-600">Please select the discount type</p>
      )}

      <div className="flex items-center justify-center gap-6 mt-10">
        {/* Fare Breakdown */}
        <div className="relative group">
          <button
            type="button"
            className="w-44 px-4 py-3 rounded-lg bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700 transition"
          >
            Fare Breakdown
          </button>

          {/* Tooltip */}
          <div className="absolute text-white invisible opacity-0 group-hover:visible group-hover:opacity-100 bottom-full left-1/2 -translate-x-1/2 mb-3 w-72 transition-all duration-300 ease-out transform group-hover:translate-y-0 translate-y-2 z-50">
            <div className="relative p-4 bg-gradient-to-br from-gray-900/95 to-gray-800/95 backdrop-blur-md rounded-2xl border border-white/10 shadow-[0_0_30px_rgba(79,70,229,0.15)]">
              <div className="space-y-3 text-sm text-white">
                <div className="flex justify-between">
                  <span>Base</span>
                  <span>
                    {summaryDetails?.weekendRent +
                      summaryDetails?.weekdayRent ?? "-"}
                  </span>
                </div>

                {inputValues?.discount ? (
                  <div className="flex justify-between">
                    <span>Discount {discountMode ? "₹" : "%"}</span>
                    <span className="font-medium">
                      {inputValues.discount || "-"}
                    </span>
                  </div>
                ) : (
                  <></>
                )}

                {inputValues?.discount ? (
                  <div className="flex justify-between">
                    <span>Discounted Base Amount</span>
                    <span>{calculateFinalPrice()?.discountedBase ?? "-"}</span>
                  </div>
                ) : (
                  ""
                )}

                <div className="flex justify-between">
                  <span>Security Deposit</span>
                  <span>{summaryDetails?.securityDeposit ?? "-"}</span>
                </div>

                {inputValues?.deliverycharges ? (
                  <div className="flex justify-between">
                    <span>Delivery Charge</span>
                    <span>{inputValues.deliverycharges}</span>
                  </div>
                ) : (
                  <></>
                )}

                {inputValues?.pickupcharges ? (
                  <div className="flex justify-between">
                    <span>Pickup Charge</span>
                    <span>{inputValues.pickupcharges}</span>
                  </div>
                ) : (
                  <></>
                )}

                <div className="flex justify-between">
                  <span>Tax</span>
                  <span>{taxAmount ?? "-"}</span>
                </div>

                <div className="flex justify-between font-semibold">
                  <span>Total</span>
                  <span>{calculateFinalPrice()?.finalPrice}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Update Button */}
        <button
          onClick={postVehicleBooking}
          className="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium group"
        >
          <div className="relative overflow-hidden h-6">
            <p className="group-hover:-translate-y-7 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
              Update
            </p>
            <p className="absolute top-7 left-0 group-hover:top-0 duration-[1.125s] ease-[cubic-bezier(0.19,1,0.22,1)]">
              Update
            </p>
          </div>
        </button>
      </div>

      {fleetBookingStatus?.inverted?.paymentPending ===
        String(summaryDetails?.bookingStatus) && (
        <>
          <div>
            <input
              type="text"
              className="w-full border border-gray-400 mt-4 rounded-md h-14 p-4"
              placeholder="Enter the Comment"
              value={vehicleDetailsData.comment || ""}
              onChange={(e) =>
                setVehicleDetailsData((prev) => ({
                  ...prev,
                  comment: e.target.value,
                }))
              }
            />
          </div>
          <button
            onClick={() => {
              initiateBookingAPI("Close");
            }}
            class="flex justify-center text-white bg-gradient-to-r from-red-500 via-red-600 to-red-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 shadow-lg font-medium rounded-lg text-md px-5 py-2.5 text-center mr-2 mb-2 mt-4"
            type="button"
          >
            Close Inquiry
          </button>
        </>
      )}
    </div>
  );
};

export default Updatedetails;
